import React, { useEffect, useState } from "react";
import axios from "axios";
import { API_URL } from "../config";

function Prices() {
  const [prices, setPrices] = useState([]);
  const [editingId, setEditingId] = useState(null);
  const [newPrice, setNewPrice] = useState("");

  useEffect(() => {
    axios.get(`${API_URL}/prices`)
      .then((res) => setPrices(res.data))
      .catch((err) => console.log(err));
  }, []);

  const savePrice = (id) => {
    axios.put(`${API_URL}/prices/${id}`, {
      ...prices.find(item => item.id === id),
      price: newPrice
    })
      .then((res) => {
        setPrices(prices.map(item =>
          item.id === id ? { ...item, price: newPrice } : item
        ));
        setEditingId(null);
        setNewPrice("");
      })
      .catch((err) => console.log(err));
  };

  return (
    <div className="p-6">
      {/* Header Card */}
      <div className="bg-white/10 backdrop-blur-xl rounded-2xl p-6 mb-6 border border-white/20">
        <div className="flex flex-col md:flex-row md:items-center md:justify-between gap-4">
          <div>
            <h2 className="text-3xl font-bold text-white flex items-center gap-3">
              <span className="text-4xl">💰</span> Trip Prices
            </h2>
            <p className="text-cyan-200 mt-1">Manage pricing for all trips and services</p>
          </div>

          <div className="bg-gradient-to-br from-yellow-500 to-orange-500 rounded-xl px-5 py-3 text-white">
            <p className="text-sm opacity-80">Total Items</p>
            <p className="text-2xl font-bold">{prices.length}</p>
          </div>
        </div>
      </div>

      {/* Prices Grid */}
      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-4">
        {prices.map((item, index) => (
          <div key={item.id} className="bg-white/10 backdrop-blur-xl rounded-2xl overflow-hidden border border-white/20
            hover:bg-white/15 transition-all duration-300 group">
            {/* Card Header */}
            <div className="bg-gradient-to-r from-blue-600 to-cyan-600 px-4 py-3">
              <div className="flex items-center justify-between">
                <span className="text-white/60 text-sm">#{index + 1}</span>
                <span className="text-2xl">
                  {item.trip?.toLowerCase().includes('course') ? '🎓' :
                    item.trip?.toLowerCase().includes('special') ? '✨' :
                      item.trip?.toLowerCase().includes('camp') ? '🏕️' : '🚤'}
                </span>
              </div>
              <h3 className="text-white font-bold text-lg mt-1">{item.trip}</h3>
            </div>

            {/* Card Body */}
            <div className="p-4">
              <div className="text-center py-4">
                {editingId === item.id ? (
                  <div className="flex items-center justify-center gap-2">
                    <span className="text-2xl text-white">$</span>
                    <input
                      type="number"
                      value={newPrice}
                      onChange={(e) => setNewPrice(e.target.value)}
                      className="w-24 px-3 py-2 bg-white/10 border border-white/30 rounded-lg 
                        text-white text-2xl font-bold text-center focus:outline-none focus:ring-2 focus:ring-cyan-400"
                      autoFocus
                    />
                  </div>
                ) : (
                  <div className="text-4xl font-bold text-white">
                    ${item.price}
                  </div>
                )}
                <p className="text-white/50 text-sm mt-2">per person</p>
              </div>

              {/* Action Button */}
              <div className="mt-4">
                {editingId === item.id ? (
                  <div className="flex gap-2">
                    <button
                      onClick={() => savePrice(item.id)}
                      className="flex-1 bg-gradient-to-r from-green-500 to-emerald-500 text-white 
                        px-4 py-2 rounded-lg transition-all duration-300 flex items-center justify-center gap-2
                        hover:from-green-600 hover:to-emerald-600"
                    >
                      <svg className="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M5 13l4 4L19 7" />
                      </svg>
                      Save
                    </button>
                    <button
                      onClick={() => { setEditingId(null); setNewPrice(""); }}
                      className="bg-white/10 text-white px-4 py-2 rounded-lg transition-all duration-300
                        hover:bg-white/20"
                    >
                      Cancel
                    </button>
                  </div>
                ) : (
                  <button
                    onClick={() => { setEditingId(item.id); setNewPrice(item.price); }}
                    className="w-full bg-white/10 hover:bg-blue-500 text-white 
                      px-4 py-2 rounded-lg transition-all duration-300 flex items-center justify-center gap-2
                      border border-white/20 hover:border-blue-500"
                  >
                    <svg className="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M11 5H6a2 2 0 00-2 2v11a2 2 0 002 2h11a2 2 0 002-2v-5m-1.414-9.414a2 2 0 112.828 2.828L11.828 15H9v-2.828l8.586-8.586z" />
                    </svg>
                    Edit Price
                  </button>
                )}
              </div>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
}

export default Prices;
